import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
function PopIncome(props) {
  const {open, close} = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = ['2023, 05, 12 (4500)', '2022, 01, 23 (4000)', '2020, 12, 20 (3500)', '2021, 09, 10 (3000)', '2023, 05, 12 (4500)', '2022, 01, 23 (4000)', '2020, 12, 20 (3500)', '2021, 09, 10 (3000)'];
  const handleClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Modal open={open} close={close} type="com_input" popSize="xs">
      <h2 className="pop_tit">연봉 관리</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="tit_field">연봉(만원)</li>
          <li className="input_field">
            <input type="text" className="input" defaultValue={`4500`} />
          </li>
          <li className="tit_field">변경일</li>
          <li className="input_field">
            <input type="date" className="com_datepicker" defaultValue={`2022-01-01`} />
          </li>
        </ul>
        <ul className="com_scroll_list pick">
          {listItems.map((item, index) => (
            <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => handleClick(index)}>
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopIncome;
